// import R from 'ramda';
// import {Subject} from 'rxjs';
import { ajaxWithProgress, fetch } from 'common/ajax';

const STIP_BASE_URL = process.env.REACT_APP_STIP_BASE_URL;

const getCountriesUrl = () => `${STIP_BASE_URL}/geography/countries`;
const getDegreesUrl = () => `${STIP_BASE_URL}/degrees`;
const getDepartmentsUrl = () => `${STIP_BASE_URL}/departments`;
const getProjectUrl = projectKey => `${STIP_BASE_URL}/projects/${projectKey}`;
const getSubdivisionsUrl = countryCode =>
  `${STIP_BASE_URL}/geography/countries/${countryCode}/subdivisions`;
const getLicenseTypesUrl = () => `${STIP_BASE_URL}/license-types`;
const getSubmissionUploadUrl = projectId =>
  `${STIP_BASE_URL}/projects/${projectId}/dissertations`;

export const fetchCountries = () => fetch(getCountriesUrl());
export const fetchDegrees = () => fetch(getDegreesUrl());
export const fetchDepartments = () => fetch(getDepartmentsUrl());
export const fetchProject = projectKey => fetch(getProjectUrl(projectKey));
export const fetchSubdivisions = countryCode =>
  fetch(getSubdivisionsUrl(countryCode));
export const fetchLicenseTypes = () => fetch(getLicenseTypesUrl());

export const uploadSubmission = (formData, projectId) =>
  ajaxWithProgress({
    method: 'POST',
    url: getSubmissionUploadUrl(projectId),
    body: formData,
  });

// const fakeAjaxUpload = (numProgressEvents, interval) => {
//   const subject$ = new Subject();
//
//   R.range(0, numProgressEvents + 1)
//       .map(num => ({
//         num,
//         loaded: (100 / numProgressEvents) * num,
//       }))
//       .forEach(({num, loaded}) => {
//         setTimeout(() => {
//           subject$.next(new ProgressEvent('progress', {
//             loaded,
//             total: 100,
//             lengthComputable: true,
//           }));
//         }, (num * interval));
//       });
//
//   setTimeout(() => {
//     subject$.next({response: {ok: 'ok'}});
//     subject$.complete();
//   }, ((numProgressEvents + 1) * interval * Math.ceil(numProgressEvents / 4)));
//
//   return subject$;
// };
//
// export const uploadSubmission = (formData, projectId) => {
//   console.log('Fake upload submission, formData: %O, projectId: %O', formData, projectId);
//   return fakeAjaxUpload(10, 100);
// };



// WEBPACK FOOTER //
// ./src/common/stipAjax.js